import React, { createContext, useState, useEffect, useCallback } from "react";
import { authApi } from "../api/auth";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const resp = await authApi.refresh();
      setUser(resp.data.user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const resp = await authApi.login({ email, password });
    setUser(resp.data.user);
    return resp.data.user;
  };

  // No name: signup asks for an address and a password. The server derives a
  // display name from the address, Stripe supplies the real one at checkout,
  // and account settings let anyone set it themselves.
  const signup = async (email, password, marketingConsent = false) => {
    const resp = await authApi.signup({ email, password, marketing_consent: marketingConsent });
    return resp.data;
  };

  const logout = async () => {
    await authApi.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
